// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file memory/memory.proto (package lvdr.v2.memory, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Sensitivity } from "../common/sensitivity_pb";
import { file_common_sensitivity } from "../common/sensitivity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file memory/memory.proto.
 */
export const file_memory_memory: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_sensitivity]);

/**
 * @generated from message lvdr.v2.memory.Source
 */
export type Source = Message<"lvdr.v2.memory.Source"> & {
  /**
   * @generated from field: lvdr.v2.memory.SourceType source_type = 1;
   */
  sourceType: SourceType;

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * @generated from field: string research_id = 3;
   */
  researchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp extracted_at = 4;
   */
  extractedAt?: Timestamp | undefined;

  /**
   * @generated from field: string excerpt = 5;
   */
  excerpt: string;
};

/**
 * Describes the message lvdr.v2.memory.Source.
 * Use `create(SourceSchema)` to create a new message.
 */
export const SourceSchema: GenMessage<Source> = /*@__PURE__*/
  messageDesc(file_memory_memory, 0);

/**
 * @generated from message lvdr.v2.memory.MemoryEntity
 */
export type MemoryEntity = Message<"lvdr.v2.memory.MemoryEntity"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string scope = 3;
   */
  scope: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: lvdr.v2.memory.EntityType entity_type = 5;
   */
  entityType: EntityType;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: repeated string aliases = 7;
   */
  aliases: string[];

  /**
   * @generated from field: double confidence = 8;
   */
  confidence: number;

  /**
   * @generated from field: lvdr.v2.memory.Source source = 9;
   */
  source?: Source | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_from = 10;
   */
  validFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 11;
   */
  validUntil?: Timestamp | undefined;

  /**
   * @generated from field: string user_notes = 12;
   */
  userNotes: string;

  /**
   * @generated from field: int32 importance = 13;
   */
  importance: number;

  /**
   * @generated from field: repeated string tags = 14;
   */
  tags: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_accessed_at = 17;
   */
  lastAccessedAt?: Timestamp | undefined;

  /**
   * @generated from field: map<string, string> metadata = 18;
   */
  metadata: { [key: string]: string };

  /**
   * Sensitivity gates outbound LLM/voice traffic. See common/sensitivity.proto.
   *
   * @generated from field: lvdr.v2.common.Sensitivity sensitivity = 19;
   */
  sensitivity: Sensitivity;
};

/**
 * Describes the message lvdr.v2.memory.MemoryEntity.
 * Use `create(MemoryEntitySchema)` to create a new message.
 */
export const MemoryEntitySchema: GenMessage<MemoryEntity> = /*@__PURE__*/
  messageDesc(file_memory_memory, 1);

/**
 * @generated from message lvdr.v2.memory.MemoryRelation
 */
export type MemoryRelation = Message<"lvdr.v2.memory.MemoryRelation"> & {
  /**
   * @generated from field: string relation_id = 1;
   */
  relationId: string;

  /**
   * @generated from field: string source_entity_id = 2;
   */
  sourceEntityId: string;

  /**
   * @generated from field: string target_entity_id = 3;
   */
  targetEntityId: string;

  /**
   * @generated from field: string relation_type = 4;
   */
  relationType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: double confidence = 6;
   */
  confidence: number;

  /**
   * @generated from field: lvdr.v2.memory.Source source = 7;
   */
  source?: Source | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.memory.MemoryRelation.
 * Use `create(MemoryRelationSchema)` to create a new message.
 */
export const MemoryRelationSchema: GenMessage<MemoryRelation> = /*@__PURE__*/
  messageDesc(file_memory_memory, 2);

/**
 * @generated from message lvdr.v2.memory.MemoryTopic
 */
export type MemoryTopic = Message<"lvdr.v2.memory.MemoryTopic"> & {
  /**
   * @generated from field: string topic_id = 1;
   */
  topicId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string scope = 3;
   */
  scope: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated string entity_ids = 6;
   */
  entityIds: string[];

  /**
   * @generated from field: bool auto_generated = 7;
   */
  autoGenerated: boolean;

  /**
   * @generated from field: int32 entity_count = 8;
   */
  entityCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.memory.MemoryTopic.
 * Use `create(MemoryTopicSchema)` to create a new message.
 */
export const MemoryTopicSchema: GenMessage<MemoryTopic> = /*@__PURE__*/
  messageDesc(file_memory_memory, 3);

/**
 * @generated from message lvdr.v2.memory.ReviewItem
 */
export type ReviewItem = Message<"lvdr.v2.memory.ReviewItem"> & {
  /**
   * @generated from field: string review_id = 1;
   */
  reviewId: string;

  /**
   * @generated from field: lvdr.v2.memory.MemoryEntity entity = 2;
   */
  entity?: MemoryEntity | undefined;

  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryRelation relations = 3;
   */
  relations: MemoryRelation[];

  /**
   * @generated from field: string suggested_topic = 4;
   */
  suggestedTopic: string;

  /**
   * @generated from field: lvdr.v2.memory.Source source = 5;
   */
  source?: Source | undefined;

  /**
   * @generated from field: string contradiction_entity_id = 6;
   */
  contradictionEntityId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.memory.ReviewItem.
 * Use `create(ReviewItemSchema)` to create a new message.
 */
export const ReviewItemSchema: GenMessage<ReviewItem> = /*@__PURE__*/
  messageDesc(file_memory_memory, 4);

/**
 * @generated from message lvdr.v2.memory.EntityWithRelations
 */
export type EntityWithRelations = Message<"lvdr.v2.memory.EntityWithRelations"> & {
  /**
   * @generated from field: lvdr.v2.memory.MemoryEntity entity = 1;
   */
  entity?: MemoryEntity | undefined;

  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryRelation outgoing_relations = 2;
   */
  outgoingRelations: MemoryRelation[];

  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryRelation incoming_relations = 3;
   */
  incomingRelations: MemoryRelation[];

  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryEntity related_entities = 4;
   */
  relatedEntities: MemoryEntity[];
};

/**
 * Describes the message lvdr.v2.memory.EntityWithRelations.
 * Use `create(EntityWithRelationsSchema)` to create a new message.
 */
export const EntityWithRelationsSchema: GenMessage<EntityWithRelations> = /*@__PURE__*/
  messageDesc(file_memory_memory, 5);

/**
 * @generated from message lvdr.v2.memory.GraphSubset
 */
export type GraphSubset = Message<"lvdr.v2.memory.GraphSubset"> & {
  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryEntity entities = 1;
   */
  entities: MemoryEntity[];

  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryRelation relations = 2;
   */
  relations: MemoryRelation[];
};

/**
 * Describes the message lvdr.v2.memory.GraphSubset.
 * Use `create(GraphSubsetSchema)` to create a new message.
 */
export const GraphSubsetSchema: GenMessage<GraphSubset> = /*@__PURE__*/
  messageDesc(file_memory_memory, 6);

/**
 * @generated from message lvdr.v2.memory.ListEntitiesRequest
 */
export type ListEntitiesRequest = Message<"lvdr.v2.memory.ListEntitiesRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: lvdr.v2.memory.EntityType entity_type = 2;
   */
  entityType: EntityType;

  /**
   * @generated from field: string topic_id = 3;
   */
  topicId: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: string query = 5;
   */
  query: string;

  /**
   * @generated from field: int32 limit = 6;
   */
  limit: number;

  /**
   * @generated from field: string cursor = 7;
   */
  cursor: string;
};

/**
 * Describes the message lvdr.v2.memory.ListEntitiesRequest.
 * Use `create(ListEntitiesRequestSchema)` to create a new message.
 */
export const ListEntitiesRequestSchema: GenMessage<ListEntitiesRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 7);

/**
 * @generated from message lvdr.v2.memory.GetEntityRequest
 */
export type GetEntityRequest = Message<"lvdr.v2.memory.GetEntityRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: int32 relation_depth = 2;
   */
  relationDepth: number;
};

/**
 * Describes the message lvdr.v2.memory.GetEntityRequest.
 * Use `create(GetEntityRequestSchema)` to create a new message.
 */
export const GetEntityRequestSchema: GenMessage<GetEntityRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 8);

/**
 * @generated from message lvdr.v2.memory.CreateEntityRequest
 */
export type CreateEntityRequest = Message<"lvdr.v2.memory.CreateEntityRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: lvdr.v2.memory.EntityType entity_type = 3;
   */
  entityType: EntityType;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated string aliases = 5;
   */
  aliases: string[];

  /**
   * @generated from field: string user_notes = 6;
   */
  userNotes: string;

  /**
   * @generated from field: int32 importance = 7;
   */
  importance: number;

  /**
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * @generated from field: google.protobuf.Timestamp valid_from = 9;
   */
  validFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 10;
   */
  validUntil?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.memory.CreateEntityRequest.
 * Use `create(CreateEntityRequestSchema)` to create a new message.
 */
export const CreateEntityRequestSchema: GenMessage<CreateEntityRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 9);

/**
 * @generated from message lvdr.v2.memory.UpdateEntityRequest
 */
export type UpdateEntityRequest = Message<"lvdr.v2.memory.UpdateEntityRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * @generated from field: repeated string aliases = 4;
   */
  aliases: string[];

  /**
   * @generated from field: optional string user_notes = 5;
   */
  userNotes?: string | undefined;

  /**
   * @generated from field: optional int32 importance = 6;
   */
  importance?: number | undefined;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: optional lvdr.v2.memory.EntityType entity_type = 8;
   */
  entityType?: EntityType | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_from = 9;
   */
  validFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 10;
   */
  validUntil?: Timestamp | undefined;

  /**
   * @generated from field: optional lvdr.v2.common.Sensitivity sensitivity = 11;
   */
  sensitivity?: Sensitivity | undefined;
};

/**
 * Describes the message lvdr.v2.memory.UpdateEntityRequest.
 * Use `create(UpdateEntityRequestSchema)` to create a new message.
 */
export const UpdateEntityRequestSchema: GenMessage<UpdateEntityRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 10);

/**
 * @generated from message lvdr.v2.memory.DeleteEntityRequest
 */
export type DeleteEntityRequest = Message<"lvdr.v2.memory.DeleteEntityRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;
};

/**
 * Describes the message lvdr.v2.memory.DeleteEntityRequest.
 * Use `create(DeleteEntityRequestSchema)` to create a new message.
 */
export const DeleteEntityRequestSchema: GenMessage<DeleteEntityRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 11);

/**
 * @generated from message lvdr.v2.memory.CreateRelationRequest
 */
export type CreateRelationRequest = Message<"lvdr.v2.memory.CreateRelationRequest"> & {
  /**
   * @generated from field: string source_entity_id = 1;
   */
  sourceEntityId: string;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId: string;

  /**
   * @generated from field: string relation_type = 3;
   */
  relationType: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;
};

/**
 * Describes the message lvdr.v2.memory.CreateRelationRequest.
 * Use `create(CreateRelationRequestSchema)` to create a new message.
 */
export const CreateRelationRequestSchema: GenMessage<CreateRelationRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 12);

/**
 * @generated from message lvdr.v2.memory.DeleteRelationRequest
 */
export type DeleteRelationRequest = Message<"lvdr.v2.memory.DeleteRelationRequest"> & {
  /**
   * @generated from field: string relation_id = 1;
   */
  relationId: string;
};

/**
 * Describes the message lvdr.v2.memory.DeleteRelationRequest.
 * Use `create(DeleteRelationRequestSchema)` to create a new message.
 */
export const DeleteRelationRequestSchema: GenMessage<DeleteRelationRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 13);

/**
 * @generated from message lvdr.v2.memory.ListTopicsRequest
 */
export type ListTopicsRequest = Message<"lvdr.v2.memory.ListTopicsRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor: string;
};

/**
 * Describes the message lvdr.v2.memory.ListTopicsRequest.
 * Use `create(ListTopicsRequestSchema)` to create a new message.
 */
export const ListTopicsRequestSchema: GenMessage<ListTopicsRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 14);

/**
 * @generated from message lvdr.v2.memory.CreateTopicRequest
 */
export type CreateTopicRequest = Message<"lvdr.v2.memory.CreateTopicRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string entity_ids = 4;
   */
  entityIds: string[];
};

/**
 * Describes the message lvdr.v2.memory.CreateTopicRequest.
 * Use `create(CreateTopicRequestSchema)` to create a new message.
 */
export const CreateTopicRequestSchema: GenMessage<CreateTopicRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 15);

/**
 * @generated from message lvdr.v2.memory.UpdateTopicRequest
 */
export type UpdateTopicRequest = Message<"lvdr.v2.memory.UpdateTopicRequest"> & {
  /**
   * @generated from field: string topic_id = 1;
   */
  topicId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string | undefined;

  /**
   * @generated from field: repeated string add_entity_ids = 4;
   */
  addEntityIds: string[];

  /**
   * @generated from field: repeated string remove_entity_ids = 5;
   */
  removeEntityIds: string[];
};

/**
 * Describes the message lvdr.v2.memory.UpdateTopicRequest.
 * Use `create(UpdateTopicRequestSchema)` to create a new message.
 */
export const UpdateTopicRequestSchema: GenMessage<UpdateTopicRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 16);

/**
 * @generated from message lvdr.v2.memory.DeleteTopicRequest
 */
export type DeleteTopicRequest = Message<"lvdr.v2.memory.DeleteTopicRequest"> & {
  /**
   * @generated from field: string topic_id = 1;
   */
  topicId: string;
};

/**
 * Describes the message lvdr.v2.memory.DeleteTopicRequest.
 * Use `create(DeleteTopicRequestSchema)` to create a new message.
 */
export const DeleteTopicRequestSchema: GenMessage<DeleteTopicRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 17);

/**
 * @generated from message lvdr.v2.memory.GetGraphRequest
 */
export type GetGraphRequest = Message<"lvdr.v2.memory.GetGraphRequest"> & {
  /**
   * @generated from field: string entity_id = 1;
   */
  entityId: string;

  /**
   * @generated from field: int32 depth = 2;
   */
  depth: number;
};

/**
 * Describes the message lvdr.v2.memory.GetGraphRequest.
 * Use `create(GetGraphRequestSchema)` to create a new message.
 */
export const GetGraphRequestSchema: GenMessage<GetGraphRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 18);

/**
 * @generated from message lvdr.v2.memory.SearchEntitiesRequest
 */
export type SearchEntitiesRequest = Message<"lvdr.v2.memory.SearchEntitiesRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message lvdr.v2.memory.SearchEntitiesRequest.
 * Use `create(SearchEntitiesRequestSchema)` to create a new message.
 */
export const SearchEntitiesRequestSchema: GenMessage<SearchEntitiesRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 19);

/**
 * @generated from message lvdr.v2.memory.GetReviewQueueRequest
 */
export type GetReviewQueueRequest = Message<"lvdr.v2.memory.GetReviewQueueRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;
};

/**
 * Describes the message lvdr.v2.memory.GetReviewQueueRequest.
 * Use `create(GetReviewQueueRequestSchema)` to create a new message.
 */
export const GetReviewQueueRequestSchema: GenMessage<GetReviewQueueRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 20);

/**
 * @generated from message lvdr.v2.memory.ResolveReviewRequest
 */
export type ResolveReviewRequest = Message<"lvdr.v2.memory.ResolveReviewRequest"> & {
  /**
   * @generated from field: string review_id = 1;
   */
  reviewId: string;

  /**
   * @generated from field: lvdr.v2.memory.ReviewAction action = 2;
   */
  action: ReviewAction;

  /**
   * @generated from field: lvdr.v2.memory.MemoryEntity edited_entity = 3;
   */
  editedEntity?: MemoryEntity | undefined;

  /**
   * @generated from field: string merge_description = 4;
   */
  mergeDescription: string;
};

/**
 * Describes the message lvdr.v2.memory.ResolveReviewRequest.
 * Use `create(ResolveReviewRequestSchema)` to create a new message.
 */
export const ResolveReviewRequestSchema: GenMessage<ResolveReviewRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 21);

/**
 * @generated from message lvdr.v2.memory.ExportMemoryRequest
 */
export type ExportMemoryRequest = Message<"lvdr.v2.memory.ExportMemoryRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: string format = 2;
   */
  format: string;
};

/**
 * Describes the message lvdr.v2.memory.ExportMemoryRequest.
 * Use `create(ExportMemoryRequestSchema)` to create a new message.
 */
export const ExportMemoryRequestSchema: GenMessage<ExportMemoryRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 22);

/**
 * @generated from message lvdr.v2.memory.ImportMemoryRequest
 */
export type ImportMemoryRequest = Message<"lvdr.v2.memory.ImportMemoryRequest"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string scope = 2;
   */
  scope: string;
};

/**
 * Describes the message lvdr.v2.memory.ImportMemoryRequest.
 * Use `create(ImportMemoryRequestSchema)` to create a new message.
 */
export const ImportMemoryRequestSchema: GenMessage<ImportMemoryRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 23);

/**
 * @generated from message lvdr.v2.memory.ToggleExtractionRequest
 */
export type ToggleExtractionRequest = Message<"lvdr.v2.memory.ToggleExtractionRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: lvdr.v2.memory.ExtractionDepth depth = 3;
   */
  depth: ExtractionDepth;

  /**
   * @generated from field: double confidence_threshold = 4;
   */
  confidenceThreshold: number;

  /**
   * @generated from field: int32 max_entities_per_run = 5;
   */
  maxEntitiesPerRun: number;
};

/**
 * Describes the message lvdr.v2.memory.ToggleExtractionRequest.
 * Use `create(ToggleExtractionRequestSchema)` to create a new message.
 */
export const ToggleExtractionRequestSchema: GenMessage<ToggleExtractionRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 24);

/**
 * @generated from message lvdr.v2.memory.SubscribeMemoryRequest
 */
export type SubscribeMemoryRequest = Message<"lvdr.v2.memory.SubscribeMemoryRequest"> & {
  /**
   * @generated from field: string scope = 1;
   */
  scope: string;
};

/**
 * Describes the message lvdr.v2.memory.SubscribeMemoryRequest.
 * Use `create(SubscribeMemoryRequestSchema)` to create a new message.
 */
export const SubscribeMemoryRequestSchema: GenMessage<SubscribeMemoryRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 25);

/**
 * @generated from message lvdr.v2.memory.UnsubscribeMemoryRequest
 */
export type UnsubscribeMemoryRequest = Message<"lvdr.v2.memory.UnsubscribeMemoryRequest"> & {
};

/**
 * Describes the message lvdr.v2.memory.UnsubscribeMemoryRequest.
 * Use `create(UnsubscribeMemoryRequestSchema)` to create a new message.
 */
export const UnsubscribeMemoryRequestSchema: GenMessage<UnsubscribeMemoryRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 26);

/**
 * @generated from message lvdr.v2.memory.GetMemorySettingsRequest
 */
export type GetMemorySettingsRequest = Message<"lvdr.v2.memory.GetMemorySettingsRequest"> & {
};

/**
 * Describes the message lvdr.v2.memory.GetMemorySettingsRequest.
 * Use `create(GetMemorySettingsRequestSchema)` to create a new message.
 */
export const GetMemorySettingsRequestSchema: GenMessage<GetMemorySettingsRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 27);

/**
 * @generated from message lvdr.v2.memory.UpdateMemorySettingsRequest
 */
export type UpdateMemorySettingsRequest = Message<"lvdr.v2.memory.UpdateMemorySettingsRequest"> & {
  /**
   * @generated from field: lvdr.v2.memory.TransparencyLevel transparency = 1;
   */
  transparency: TransparencyLevel;

  /**
   * @generated from field: lvdr.v2.memory.ExtractionDepth default_depth = 2;
   */
  defaultDepth: ExtractionDepth;

  /**
   * @generated from field: double default_confidence_threshold = 3;
   */
  defaultConfidenceThreshold: number;

  /**
   * @generated from field: int32 default_max_entities_per_run = 4;
   */
  defaultMaxEntitiesPerRun: number;

  /**
   * @generated from field: double auto_approve_threshold = 5;
   */
  autoApproveThreshold: number;
};

/**
 * Describes the message lvdr.v2.memory.UpdateMemorySettingsRequest.
 * Use `create(UpdateMemorySettingsRequestSchema)` to create a new message.
 */
export const UpdateMemorySettingsRequestSchema: GenMessage<UpdateMemorySettingsRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 28);

/**
 * @generated from message lvdr.v2.memory.BatchApproveReviewsRequest
 */
export type BatchApproveReviewsRequest = Message<"lvdr.v2.memory.BatchApproveReviewsRequest"> & {
};

/**
 * Describes the message lvdr.v2.memory.BatchApproveReviewsRequest.
 * Use `create(BatchApproveReviewsRequestSchema)` to create a new message.
 */
export const BatchApproveReviewsRequestSchema: GenMessage<BatchApproveReviewsRequest> = /*@__PURE__*/
  messageDesc(file_memory_memory, 29);

/**
 * @generated from message lvdr.v2.memory.BatchApproveReviewsResponse
 */
export type BatchApproveReviewsResponse = Message<"lvdr.v2.memory.BatchApproveReviewsResponse"> & {
  /**
   * @generated from field: int32 approved_count = 1;
   */
  approvedCount: number;
};

/**
 * Describes the message lvdr.v2.memory.BatchApproveReviewsResponse.
 * Use `create(BatchApproveReviewsResponseSchema)` to create a new message.
 */
export const BatchApproveReviewsResponseSchema: GenMessage<BatchApproveReviewsResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 30);

/**
 * @generated from message lvdr.v2.memory.EntityResponse
 */
export type EntityResponse = Message<"lvdr.v2.memory.EntityResponse"> & {
  /**
   * @generated from field: lvdr.v2.memory.EntityWithRelations entity = 1;
   */
  entity?: EntityWithRelations | undefined;
};

/**
 * Describes the message lvdr.v2.memory.EntityResponse.
 * Use `create(EntityResponseSchema)` to create a new message.
 */
export const EntityResponseSchema: GenMessage<EntityResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 31);

/**
 * @generated from message lvdr.v2.memory.EntityListResponse
 */
export type EntityListResponse = Message<"lvdr.v2.memory.EntityListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryEntity entities = 1;
   */
  entities: MemoryEntity[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message lvdr.v2.memory.EntityListResponse.
 * Use `create(EntityListResponseSchema)` to create a new message.
 */
export const EntityListResponseSchema: GenMessage<EntityListResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 32);

/**
 * @generated from message lvdr.v2.memory.TopicResponse
 */
export type TopicResponse = Message<"lvdr.v2.memory.TopicResponse"> & {
  /**
   * @generated from field: lvdr.v2.memory.MemoryTopic topic = 1;
   */
  topic?: MemoryTopic | undefined;
};

/**
 * Describes the message lvdr.v2.memory.TopicResponse.
 * Use `create(TopicResponseSchema)` to create a new message.
 */
export const TopicResponseSchema: GenMessage<TopicResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 33);

/**
 * @generated from message lvdr.v2.memory.TopicListResponse
 */
export type TopicListResponse = Message<"lvdr.v2.memory.TopicListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryTopic topics = 1;
   */
  topics: MemoryTopic[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message lvdr.v2.memory.TopicListResponse.
 * Use `create(TopicListResponseSchema)` to create a new message.
 */
export const TopicListResponseSchema: GenMessage<TopicListResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 34);

/**
 * @generated from message lvdr.v2.memory.GraphResponse
 */
export type GraphResponse = Message<"lvdr.v2.memory.GraphResponse"> & {
  /**
   * @generated from field: lvdr.v2.memory.GraphSubset graph = 1;
   */
  graph?: GraphSubset | undefined;

  /**
   * @generated from field: string center_entity_id = 2;
   */
  centerEntityId: string;
};

/**
 * Describes the message lvdr.v2.memory.GraphResponse.
 * Use `create(GraphResponseSchema)` to create a new message.
 */
export const GraphResponseSchema: GenMessage<GraphResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 35);

/**
 * @generated from message lvdr.v2.memory.SearchEntitiesResponse
 */
export type SearchEntitiesResponse = Message<"lvdr.v2.memory.SearchEntitiesResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.memory.MemoryEntity entities = 1;
   */
  entities: MemoryEntity[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.memory.SearchEntitiesResponse.
 * Use `create(SearchEntitiesResponseSchema)` to create a new message.
 */
export const SearchEntitiesResponseSchema: GenMessage<SearchEntitiesResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 36);

/**
 * @generated from message lvdr.v2.memory.ReviewQueueResponse
 */
export type ReviewQueueResponse = Message<"lvdr.v2.memory.ReviewQueueResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.memory.ReviewItem items = 1;
   */
  items: ReviewItem[];

  /**
   * @generated from field: int32 pending_count = 2;
   */
  pendingCount: number;

  /**
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message lvdr.v2.memory.ReviewQueueResponse.
 * Use `create(ReviewQueueResponseSchema)` to create a new message.
 */
export const ReviewQueueResponseSchema: GenMessage<ReviewQueueResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 37);

/**
 * @generated from message lvdr.v2.memory.ResolveReviewResponse
 */
export type ResolveReviewResponse = Message<"lvdr.v2.memory.ResolveReviewResponse"> & {
  /**
   * @generated from field: lvdr.v2.memory.MemoryEntity resolved_entity = 1;
   */
  resolvedEntity?: MemoryEntity | undefined;
};

/**
 * Describes the message lvdr.v2.memory.ResolveReviewResponse.
 * Use `create(ResolveReviewResponseSchema)` to create a new message.
 */
export const ResolveReviewResponseSchema: GenMessage<ResolveReviewResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 38);

/**
 * @generated from message lvdr.v2.memory.ExportMemoryResponse
 */
export type ExportMemoryResponse = Message<"lvdr.v2.memory.ExportMemoryResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string format = 2;
   */
  format: string;

  /**
   * @generated from field: int32 entity_count = 3;
   */
  entityCount: number;
};

/**
 * Describes the message lvdr.v2.memory.ExportMemoryResponse.
 * Use `create(ExportMemoryResponseSchema)` to create a new message.
 */
export const ExportMemoryResponseSchema: GenMessage<ExportMemoryResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 39);

/**
 * @generated from message lvdr.v2.memory.ImportMemoryResponse
 */
export type ImportMemoryResponse = Message<"lvdr.v2.memory.ImportMemoryResponse"> & {
  /**
   * @generated from field: int32 entities_imported = 1;
   */
  entitiesImported: number;

  /**
   * @generated from field: int32 relations_imported = 2;
   */
  relationsImported: number;

  /**
   * @generated from field: int32 topics_imported = 3;
   */
  topicsImported: number;

  /**
   * @generated from field: int32 duplicates_skipped = 4;
   */
  duplicatesSkipped: number;
};

/**
 * Describes the message lvdr.v2.memory.ImportMemoryResponse.
 * Use `create(ImportMemoryResponseSchema)` to create a new message.
 */
export const ImportMemoryResponseSchema: GenMessage<ImportMemoryResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 40);

/**
 * @generated from message lvdr.v2.memory.MemorySettingsResponse
 */
export type MemorySettingsResponse = Message<"lvdr.v2.memory.MemorySettingsResponse"> & {
  /**
   * @generated from field: map<string, bool> extraction_enabled = 1;
   */
  extractionEnabled: { [key: string]: boolean };

  /**
   * @generated from field: map<string, int32> extraction_depth = 2;
   */
  extractionDepth: { [key: string]: number };

  /**
   * @generated from field: lvdr.v2.memory.TransparencyLevel transparency = 3;
   */
  transparency: TransparencyLevel;

  /**
   * @generated from field: double default_confidence_threshold = 4;
   */
  defaultConfidenceThreshold: number;

  /**
   * @generated from field: int32 default_max_entities_per_run = 5;
   */
  defaultMaxEntitiesPerRun: number;

  /**
   * @generated from field: lvdr.v2.memory.ExtractionDepth default_depth = 6;
   */
  defaultDepth: ExtractionDepth;

  /**
   * @generated from field: double auto_approve_threshold = 7;
   */
  autoApproveThreshold: number;
};

/**
 * Describes the message lvdr.v2.memory.MemorySettingsResponse.
 * Use `create(MemorySettingsResponseSchema)` to create a new message.
 */
export const MemorySettingsResponseSchema: GenMessage<MemorySettingsResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 41);

/**
 * @generated from message lvdr.v2.memory.RelationResponse
 */
export type RelationResponse = Message<"lvdr.v2.memory.RelationResponse"> & {
  /**
   * @generated from field: lvdr.v2.memory.MemoryRelation relation = 1;
   */
  relation?: MemoryRelation | undefined;
};

/**
 * Describes the message lvdr.v2.memory.RelationResponse.
 * Use `create(RelationResponseSchema)` to create a new message.
 */
export const RelationResponseSchema: GenMessage<RelationResponse> = /*@__PURE__*/
  messageDesc(file_memory_memory, 42);

/**
 * @generated from message lvdr.v2.memory.MemoryEntityChangedEvent
 */
export type MemoryEntityChangedEvent = Message<"lvdr.v2.memory.MemoryEntityChangedEvent"> & {
  /**
   * @generated from field: string change_type = 1;
   */
  changeType: string;

  /**
   * @generated from field: lvdr.v2.memory.MemoryEntity entity = 2;
   */
  entity?: MemoryEntity | undefined;
};

/**
 * Describes the message lvdr.v2.memory.MemoryEntityChangedEvent.
 * Use `create(MemoryEntityChangedEventSchema)` to create a new message.
 */
export const MemoryEntityChangedEventSchema: GenMessage<MemoryEntityChangedEvent> = /*@__PURE__*/
  messageDesc(file_memory_memory, 43);

/**
 * @generated from message lvdr.v2.memory.MemoryReviewAvailableEvent
 */
export type MemoryReviewAvailableEvent = Message<"lvdr.v2.memory.MemoryReviewAvailableEvent"> & {
  /**
   * @generated from field: int32 pending_count = 1;
   */
  pendingCount: number;

  /**
   * @generated from field: lvdr.v2.memory.ReviewItem latest_item = 2;
   */
  latestItem?: ReviewItem | undefined;
};

/**
 * Describes the message lvdr.v2.memory.MemoryReviewAvailableEvent.
 * Use `create(MemoryReviewAvailableEventSchema)` to create a new message.
 */
export const MemoryReviewAvailableEventSchema: GenMessage<MemoryReviewAvailableEvent> = /*@__PURE__*/
  messageDesc(file_memory_memory, 44);

/**
 * @generated from enum lvdr.v2.memory.EntityType
 */
export enum EntityType {
  /**
   * @generated from enum value: ENTITY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_CONCEPT = 1;
   */
  CONCEPT = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_PERSON = 2;
   */
  PERSON = 2,

  /**
   * @generated from enum value: ENTITY_TYPE_TECHNOLOGY = 3;
   */
  TECHNOLOGY = 3,

  /**
   * @generated from enum value: ENTITY_TYPE_ORGANIZATION = 4;
   */
  ORGANIZATION = 4,

  /**
   * @generated from enum value: ENTITY_TYPE_EVENT = 5;
   */
  EVENT = 5,

  /**
   * @generated from enum value: ENTITY_TYPE_FACT = 6;
   */
  FACT = 6,

  /**
   * @generated from enum value: ENTITY_TYPE_CUSTOM = 7;
   */
  CUSTOM = 7,
}

/**
 * Describes the enum lvdr.v2.memory.EntityType.
 */
export const EntityTypeSchema: GenEnum<EntityType> = /*@__PURE__*/
  enumDesc(file_memory_memory, 0);

/**
 * @generated from enum lvdr.v2.memory.SourceType
 */
export enum SourceType {
  /**
   * @generated from enum value: SOURCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOURCE_TYPE_RESEARCH_NODE = 1;
   */
  RESEARCH_NODE = 1,

  /**
   * @generated from enum value: SOURCE_TYPE_DOCUMENT = 2;
   */
  DOCUMENT = 2,

  /**
   * @generated from enum value: SOURCE_TYPE_CHAT = 3;
   */
  CHAT = 3,

  /**
   * @generated from enum value: SOURCE_TYPE_WEB = 4;
   */
  WEB = 4,

  /**
   * @generated from enum value: SOURCE_TYPE_MANUAL = 5;
   */
  MANUAL = 5,
}

/**
 * Describes the enum lvdr.v2.memory.SourceType.
 */
export const SourceTypeSchema: GenEnum<SourceType> = /*@__PURE__*/
  enumDesc(file_memory_memory, 1);

/**
 * @generated from enum lvdr.v2.memory.ReviewAction
 */
export enum ReviewAction {
  /**
   * @generated from enum value: REVIEW_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_ACTION_APPROVE = 1;
   */
  APPROVE = 1,

  /**
   * @generated from enum value: REVIEW_ACTION_EDIT_AND_APPROVE = 2;
   */
  EDIT_AND_APPROVE = 2,

  /**
   * @generated from enum value: REVIEW_ACTION_DISMISS = 3;
   */
  DISMISS = 3,

  /**
   * @generated from enum value: REVIEW_ACTION_DISMISS_AND_BLOCK = 4;
   */
  DISMISS_AND_BLOCK = 4,

  /**
   * @generated from enum value: REVIEW_ACTION_KEEP_NEW = 5;
   */
  KEEP_NEW = 5,

  /**
   * @generated from enum value: REVIEW_ACTION_KEEP_OLD = 6;
   */
  KEEP_OLD = 6,

  /**
   * @generated from enum value: REVIEW_ACTION_KEEP_BOTH = 7;
   */
  KEEP_BOTH = 7,

  /**
   * @generated from enum value: REVIEW_ACTION_MERGE = 8;
   */
  MERGE = 8,
}

/**
 * Describes the enum lvdr.v2.memory.ReviewAction.
 */
export const ReviewActionSchema: GenEnum<ReviewAction> = /*@__PURE__*/
  enumDesc(file_memory_memory, 2);

/**
 * @generated from enum lvdr.v2.memory.ExtractionDepth
 */
export enum ExtractionDepth {
  /**
   * @generated from enum value: EXTRACTION_DEPTH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXTRACTION_DEPTH_SHALLOW = 1;
   */
  SHALLOW = 1,

  /**
   * @generated from enum value: EXTRACTION_DEPTH_STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: EXTRACTION_DEPTH_DEEP = 3;
   */
  DEEP = 3,
}

/**
 * Describes the enum lvdr.v2.memory.ExtractionDepth.
 */
export const ExtractionDepthSchema: GenEnum<ExtractionDepth> = /*@__PURE__*/
  enumDesc(file_memory_memory, 3);

/**
 * @generated from enum lvdr.v2.memory.TransparencyLevel
 */
export enum TransparencyLevel {
  /**
   * @generated from enum value: TRANSPARENCY_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPARENCY_LEVEL_ALWAYS_PREVIEW = 1;
   */
  ALWAYS_PREVIEW = 1,

  /**
   * @generated from enum value: TRANSPARENCY_LEVEL_RESEARCH_ONLY = 2;
   */
  RESEARCH_ONLY = 2,

  /**
   * @generated from enum value: TRANSPARENCY_LEVEL_SILENT = 3;
   */
  SILENT = 3,
}

/**
 * Describes the enum lvdr.v2.memory.TransparencyLevel.
 */
export const TransparencyLevelSchema: GenEnum<TransparencyLevel> = /*@__PURE__*/
  enumDesc(file_memory_memory, 4);

